import { Link } from 'react-router-dom';

import { useAuth } from '@/shared/auth/useAuth';
import { Button } from '@/shared/ui/Button';
import { LogoSymbol } from '@/shared/ui/Logo';
import { Skeleton } from '@/shared/ui/Skeleton';

import { quando, useMaintenanceStatus } from './useMaintenanceStatus';

/**
 * Tela de manutencao (o /maintenance do OnPoint).
 *
 * A tela e publica: a manutencao vale para quem entrou e para quem nao entrou. A
 * mensagem vem da janela aberta pela administracao da plataforma; sem previsao de
 * retorno, ela diz isso, como o OnPoint. Quando a janela termina, a mesma tela
 * avisa e devolve a pessoa ao inicio.
 */
export function MaintenancePage() {
  const consulta = useMaintenanceStatus();
  const { session } = useAuth();
  const contato = session?.tenant.access?.support_url ?? '';
  const janela = consulta.data?.current ?? null;

  return (
    <div className="flex min-h-dvh items-center justify-center bg-canvas px-5 py-10">
      <div className="w-full max-w-md text-center">
        <div className="mb-6 flex justify-center">
          <LogoSymbol size={48} />
        </div>

        {consulta.isPending ? (
          <div className="flex flex-col items-center gap-3">
            <Skeleton className="h-6 w-2/3" />
            <Skeleton className="h-16 w-full" />
          </div>
        ) : consulta.data?.under_maintenance && janela ? (
          <>
            <h1 className="text-xl font-semibold text-ink-900">
              Plataforma em manutencao
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-ink-600">
              {janela.message}
            </p>
            <p className="mt-3 text-sm text-ink-500">
              {janela.ends_at
                ? `Previsao de retorno: ${quando(janela.ends_at)}.`
                : 'Informamos que a plataforma esta temporariamente fora do ar, ainda sem previsao de retorno.'}
            </p>
            <p className="mt-3 text-sm text-ink-500">
              Em caso de duvidas,{' '}
              {contato ? (
                <a
                  href={contato}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium text-brand-600 hover:underline"
                >
                  acesse o suporte
                </a>
              ) : (
                'fale com quem administra o acesso da sua empresa'
              )}
              .
            </p>
            <Button
              variant="secondary"
              className="mt-6"
              loading={consulta.isFetching}
              onClick={() => void consulta.refetch()}
            >
              Verificar novamente
            </Button>
          </>
        ) : (
          <>
            <h1 className="text-xl font-semibold text-ink-900">
              A plataforma esta disponivel
            </h1>
            <p className="mt-3 text-sm text-ink-500">
              {consulta.isError
                ? 'Nao foi possivel confirmar a situacao da plataforma agora.'
                : 'Nao ha manutencao em andamento.'}
            </p>
            <Link
              to="/"
              className="mt-6 inline-flex text-sm font-medium text-brand-600 hover:underline"
            >
              Voltar para o inicio
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
